import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessagingService } from '../../services/messaging.service';

import { Globals } from '../../globals';
import {MessagingConstants} from '../../models/MessagingConstants';
// https://bertrandg.github.io/angular-split/#/

@Component({
  standalone: false,
  selector: 'app-case-forms',
  templateUrl: './case-forms.component.html',
  styleUrls: ['./case-forms.component.css']
})
export class CaseFormsComponent implements OnInit {
  @Input() currentPatientCaseId: string;

  constructor(
    private messagingService: MessagingService,
    public globals: Globals,
  ) {

  }

  ngOnInit() {
    this.currentPatientCaseId = this.globals.currentPatientCaseId;

    this.messagingService.componentMessageCall
      .subscribe(response => {
        if (response.event === MessagingConstants.CASE_CHANGED_EVENT) {
          this.currentPatientCaseId = response.data?.PatientCaseId;
          //console.log('CaseFormsComponent CASE_CHANGED_EVENT', response.data);
        }
      });
  }
}
